module.exports = __webpack_public_path__ + "img/home2.2a1e5478.jpg";